import { z } from 'zod';

export const dispositionSchema = z.object({
  notes: z.string().max(300, 'Notes cannot exceed 300 characters').optional(),
});
export type DispositionFormValues = z.infer<typeof dispositionSchema>;
